export default "__VITE_ASSET__RnleHAty__"